import { FC } from "react";

import { Card, Title, Label } from "shared/components";
import { copy } from "shared/assets";
import { useSubscriptionContext } from "Bands/contexts";
import { formatNumber } from "shared/utils";
import { Spacer } from "shared/layout";
import { BoldText, CenteredText, MutedText } from "shared/styles";
import { SubscriptionSummary as SubscriptionSummaryComponent } from "../components/SubscriptionSummary";

const summaryCopy = copy.subscription.summary;

export const SubscriptionSummary: FC = () => {
  const { selectedSubscription, selectedBilling } = useSubscriptionContext();

  if (!selectedSubscription) return null;

  return (
    <SubscriptionSummaryComponent>
      <Card title={summaryCopy.title} center={true}>
        <Spacer size="xl">
          <Spacer size="s" align="center">
            <Label>
              <MutedText>{summaryCopy.plan}</MutedText>
            </Label>
            <Title title={selectedSubscription.title} />
            <BoldText>
              {selectedSubscription.amount
                ? `€ ${formatNumber(selectedSubscription.amount, {
                    minimumFractionDigits: 2,
                  })} / ${selectedSubscription.billingTerm}`
                : summaryCopy.onDemand}
            </BoldText>
          </Spacer>
          {selectedBilling && (
            <Spacer size="s" align="center">
              <Label>
                <MutedText>{summaryCopy.billingInfo}</MutedText>
              </Label>
              <CenteredText as={Title} title={selectedBilling.name} />
              <BoldText>
                {selectedBilling.billingAddress.city},{" "}
                {selectedBilling.billingAddress.country}
              </BoldText>
              <BoldText>{selectedBilling.vat}</BoldText>
            </Spacer>
          )}
        </Spacer>
      </Card>
    </SubscriptionSummaryComponent>
  );
};
